var _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScalableKubernetesinline = function SvgScalableKubernetesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeWidth: 2,
    d: "M18 28.174 40.009 14.18 62 27.702v24.124L40 65.815l-22-13.99v-23.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080FF",
    d: "M39.142 27.408a2 2 0 0 1 1.716 0l8.695 4.13a2 2 0 0 1 1.09 1.355l2.137 9.234a2 2 0 0 1-.393 1.709l-6.001 7.422A2 2 0 0 1 44.83 52h-9.662a2 2 0 0 1-1.555-.742l-6-7.422a2 2 0 0 1-.394-1.709l2.137-9.234a2 2 0 0 1 1.09-1.356l8.695-4.13"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 6,
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M40 40v-9m0 9-7.037-5.611M39.999 40l-8.774 2.003M39.999 40l-3.903 8.109M40 40l7.036-5.611M40.001 40l8.774 2.003M40.001 40l3.903 8.109"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 1,
    fill: "#0080FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080FF",
    d: "M39 16a1 1 0 1 0 2 0zm1-15 .727-.687a1 1 0 0 0-1.454 0zm-4.727 3.544a1 1 0 1 0 1.454 1.374l-1.454-1.374m8 1.374a1 1 0 1 0 1.454-1.374l-1.454 1.374M41 16V1h-2v15zM39.273.313l-4 4.23 1.454 1.375 4-4.231L39.273.313m0 1.374 4 4.23 1.454-1.373-4-4.231-1.454 1.374"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B1BE",
    d: "M17.5 29.867a1 1 0 0 0 1-1.732l-1 1.732M5.01 21.5l-.232-.973a1 1 0 0 0-.727 1.259l.959-.286m.705 5.865a1 1 0 1 0 1.917-.572l-1.917.572m5.19-6.241a1 1 0 1 0-.463-1.946l.463 1.946m7.595 7.01-12.99-7.5-1 1.732 12.99 7.5 1-1.732M4.051 21.786l1.664 5.58 1.917-.572-1.664-5.579-1.917.572m1.19.688 5.664-1.35-.463-1.945-5.664 1.349.463 1.946"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4748",
    d: "M17.5 50.133a1 1 0 0 1 1 1.732l-1-1.732M5.01 58.5l-.232.973a1 1 0 0 1-.727-1.258l.959.285m.705-5.865a1 1 0 1 1 1.917.572l-1.917-.572m5.19 6.241a1 1 0 1 1-.463 1.946l.463-1.946m7.595-7.01-12.99 7.5-1-1.732 12.99-7.5 1 1.732M4.051 58.214l1.664-5.58 1.917.572-1.664 5.579-1.917-.571m1.19-.687 5.664 1.348-.463 1.946-5.664-1.349.463-1.946"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B1BE",
    d: "M62.51 29.867a1 1 0 0 1-1-1.732l1 1.732M75 21.5l.232-.973a1 1 0 0 1 .726 1.259L75 21.5m-.706 5.865a1 1 0 1 1-1.916-.572l1.916.572m-5.19-6.241a1 1 0 1 1 .464-1.946l-.464 1.946m-7.594 7.01 12.99-7.5 1 1.732-12.99 7.5-1-1.732m14.448-6.349-1.664 5.58-1.916-.572 1.664-5.579 1.916.572m-1.19.688-5.664-1.35.464-1.945 5.664 1.349-.464 1.946"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF00",
    d: "M62.5 50.133a1 1 0 0 0-1 1.732l1-1.732M74.99 58.5l.232.973a1 1 0 0 0 .727-1.258l-.959.285m-.705-5.865a1 1 0 1 0-1.917.572l1.917-.572m-5.19 6.241a1 1 0 1 0 .463 1.946l-.463-1.946m-7.595-7.01 12.99 7.5 1-1.732-12.99-7.5-1 1.732m14.448 6.349-1.663-5.58-1.917.572 1.664 5.579 1.916-.571m-1.19-.687-5.663 1.348.463 1.946 5.664-1.349-.463-1.946"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7B1BE",
    d: "M41 64a1 1 0 1 0-2 0zm-1 15-.727.687a1 1 0 0 0 1.454 0zm4.727-3.544a1 1 0 1 0-1.454-1.374l1.454 1.374m-8-1.374a1 1 0 0 0-1.454 1.374l1.454-1.374M39 64v15h2V64zm1.727 15.687 4-4.23-1.454-1.375-4 4.231 1.454 1.374m0-1.374-4-4.23-1.454 1.373 4 4.231 1.454-1.374"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 5,
    fill: "#0080FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 64,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 29,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 51,
    r: 5,
    fill: "#EB4748"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 29,
    r: 4,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 51,
    r: 5,
    fill: "#FFBF00"
  })));
};
export default SvgScalableKubernetesinline;